import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const AVAILABLE_FORMATS = ['granuli', 'strips', 'roll', 'polvere', 'stick'];
export const AVAILABLE_COLORS = ['trasparente', 'nero', 'marrone', 'marrone_scuro', 'biondo', 'biondo_scuro'];

export const COLOR_HEX = {
  trasparente: '#F0EDE5',
  nero: '#1A1A1A',
  marrone: '#6B4423',
  marrone_scuro: '#3D2817',
  biondo: '#D4A76A',
  biondo_scuro: '#8B6B3D',
};
